import 'jplayer';
jQuery(function(){
        function getTypes(ext) {
        if (ext == 'mp3' || ext == 'ogg' || ext == 'm4a') {
            return 'mp3,oga,m4a';
        } else {
            return 'mp4,mpeg,m4v';
        }
        }

        function getExt(ext) {
        if (ext == 'mp4') ext = 'm4v';
        if (ext == 'ogg') ext = 'oga';

        return ext;
        }

        function drawSector(ele, prec) {
        // console.log(ele, prec);
        var activeBorder = $('#' + ele).find('.active-border');
        if (prec > 100) prec = 100;
        var deg = prec * 3.6;
        if (deg <= 180) {
            activeBorder.css(
            'background-image',
            'linear-gradient(' +
                (90 + deg) +
                'deg, transparent 50%, #EDEDE8 50%),linear-gradient(90deg, #EDEDE8 50%, transparent 50%)'
            );
        } else {
            activeBorder.css(
            'background-image',
            'linear-gradient(' +
                (deg - 90) +
                'deg, transparent 50%, #FFCF42 50%),linear-gradient(90deg, #EDEDE8 50%, transparent 50%)'
            );
        }

        var startDeg = 0;
        activeBorder.css('transform', 'rotate(' + startDeg + 'deg)');
        $('#circle').css('transform', 'rotate(' + -startDeg + 'deg)');
        }

        //audio
        function random_ID() {
        var ID = Math.floor(Math.random() * 10001);
        // console.log(ID);
        if ($('#jp_container_' + ID).length) {
            ID = random_ID();
            // console.log(ID);
        } else {
            return ID;
        }
        }

        var this_poster = '';

        function audio_component() {
        // console.log('audio_component 1');

        $('.audio-component source').each(function () {
            // console.log('audio_component '+ index);
            var i = random_ID();

            var jpthis = $(this).parent('.audio-component');

            jpthis.replaceWith(
            '<div id="jp_container_' +
                i +
                '" class="jp-video jp-video-270p" role="application" aria-label="media player"><div class="jp-type-playlist"><div id="jquery_jplayer_' +
                i +
                '" class="jp-jplayer"></div><div class="jp-controls-holder"><div class="jp-controls"><div class="active-border"><div id="circle" class="circle"></div><span class="jp-play" role="span"tabindex="0"></span></div><div class="jp-title"></div><div class="jp-duration"></div></div></div></div></div></div></div>'
            );

            let this_src;
            let filename;
            let fileTitle;
            if (jpthis.is('a[href$="mp3"]') || jpthis.is('a[href$="m4v"]')) {
            this_src = jpthis.attr('href');
            filename = jpthis.text();
            } else {
            this_src = jpthis.find('source').attr('src');

            filename = this_src.substring(location.href.lastIndexOf('/') + 1);
            //var filename = this_src.match(/([^\/]+)(?=\.\w+$)/)[0];
            //var filename = 'test';
            filename = filename.replace(/-/g, ' ');
            filename = filename.replace(/_/g, ' ');

            fileTitle = jpthis.attr('title');

            this_poster = jpthis.attr('poster');
            }

            var extension = this_src.split('.').pop();

            // if no extension
            var allowEXT = ['mp3', 'mp4', 'm4a', 'ogg', 'm4v']; // 0 = match -1 =
            var extMatch = allowEXT.indexOf(extension);
            // alert(extMatch);
            if (extMatch == -1) {
            extension = 'mp3'; //alert('match');
            filename = 'radio internet'; // big guess
            }
            /**************************/

            var ext = getExt(extension);
            var supplied = getTypes(extension);
            //alert(this_poster);

            var jpadd = {};
            jpadd[ext] = this_src;
            jpadd.title = fileTitle ? fileTitle : filename;
            jpadd.poster = this_poster;

            // var rotateMe = $('#jp_container_' + i).find('.circle-inner');

            $('#jquery_jplayer_' + i).jPlayer({
            ready: function () {
                $(this).jPlayer('setMedia', jpadd);
            },
            play: function () {
                // To avoid multiple jPlayers playing together.
                $(this).jPlayer('pauseOthers');
            },
            swfPath:
                'https://cdnjs.cloudflare.com/ajax/libs/jplayer/2.9.2/jplayer/jquery.jplayer.swf',
            // swfPath: './scripts/jplayer.swf',
            supplied: supplied,
            globalVolume: true,
            useStateClassSkin: true,
            autoBlur: false,
            smoothPlayBar: true,
            keyEnabled: true,
            cssSelectorAncestor: '#jp_container_' + i,
            timeupdate: function (e) {
                const prec = e.jPlayer.status.currentPercentAbsolute;

                // console.log('jp_container_' + i, prec);
                drawSector('jp_container_' + i, prec);
            },
            });
        });
        }

        audio_component();

        $.ajaxSetup({
        beforeSend: function () {
            // show progress spinner
        },
        complete: function () {
            // hide progress spinner
            audio_component();
        },
        });
        //  jplayer components functions ends
        
});


// WEBPACK FOOTER //
// ./scripts/components/audio.js